import React, { useEffect } from 'react';

const MonetagScript = () => {
  useEffect(() => {
    // Prevent duplicate injections
    const existingScript = document.querySelector('script[data-zone="11403007"]');
    if (existingScript) return;

    // Wait a brief moment to ensure main content is fully loaded
    const timer = setTimeout(() => {
      // Execute the exact Monetag script logic
      (function(s){
        s.dataset.zone='11403007';
        s.src='https://nap5k.com/tag.min.js';
      })(
        [document.documentElement, document.body]
          .filter(Boolean)
          .pop()
          .appendChild(document.createElement('script'))
      );
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return null;
};

export default MonetagScript;
